module.exports = __webpack_public_path__ + "static/patterns-eafc30b0b8776d29f5e9a9090975f89d.png";